"use strict";
exports.__esModule = true;
var angular = require("angular");
var simple_filter_component_1 = require("./simple-filter.component");
var broadcast_config_1 = require("../broadcast-config");
var filter_logic_1 = require("../filter-logic");
require('./simple-filter-group.component.css');
var COMPONENT_NAME = 'smartorg.r6.reportOptions.simpleFilterGroup';
var MINIMUN_FILTERS = 2;
var SimpleFilterGroupComponent = /** @class */ (function () {
    function SimpleFilterGroupComponent($scope) {
        var _this = this;
        this.filterList = [null, null];
        $scope.$on(broadcast_config_1["default"].ADD_FILTER, function () { return _this.addSimpleFilter(); });
        $scope.$on('simpleFilter:reset', function (event, args) {
            _this.initState = args.defaultOptions.filterLogic;
            _this.generateFilterList(_this.categories, _this.numericObjects, _this.initState);
        });
    }
    SimpleFilterGroupComponent.prototype.$onChanges = function (changesObj) {
        if (changesObj.categories || changesObj.numericObjects || changesObj.initState) {
            this.generateFilterList(this.categories, this.numericObjects, this.initState);
        }
    };
    SimpleFilterGroupComponent.prototype.generateFilterList = function (categories, numericObjects, initState) {
        if ((categories || numericObjects) && initState) {
            var filterLogic = filter_logic_1.createFilterLogic(initState);
            this.filterList = this.parseSimpleFilterFromString(filterLogic);
        }
        else {
            this.filterList = [];
        }
        while (this.filterList.length < MINIMUN_FILTERS) {
            this.filterList.push(null);
        }
    };
    SimpleFilterGroupComponent.prototype.parseSimpleFilterFromString = function (filterLogic) {
        if (!filterLogic) {
            return null;
        }
        return filterLogic.children.map(function (f) {
            if (f instanceof filter_logic_1["default"]) {
                var tags = f.children;
                if (tags[0].split(':').length === 3) {
                    var _a = tags[0].split(':'), key = _a[0], e = _a[1], codedName = _a[2];
                    var entries_1 = tags.map(function (t) { return ({ name: atob(decodeURIComponent(t.split(':')[1])), selected: true }); });
                    return { key: key, name: atob(decodeURIComponent(codedName)), entries: entries_1 };
                }
                var name_1 = tags[0].split(':')[0];
                var entries = tags.map(function (t) { return ({ name: t.split(':')[1], selected: true }); });
                return { name: name_1, entries: entries };
            }
            else {
                var filterStrArr = f.split(':');
                if (filterStrArr.length === 6) {
                    var field = filterStrArr[0], key = filterStrArr[1], operator = filterStrArr[2], value = filterStrArr[3], template = filterStrArr[4], codedDisplay = filterStrArr[5];
                    if (key && field && operator && !isNaN(parseFloat(value))) {
                        return { key: key, field: field, operator: operator, value: parseFloat(value), template: template, display: atob(codedDisplay) };
                    }
                }
                else if (filterStrArr.length === 3) {
                    var key = filterStrArr[0], entry_1 = filterStrArr[1], codedName = filterStrArr[2];
                    return { key: key, entries: [{ name: atob(decodeURIComponent(entry_1)), selected: true }], name: atob(decodeURIComponent(codedName)) };
                }
                var _b = f.split(':'), name_2 = _b[0], entry = _b[1];
                return { name: name_2, entries: [{ name: entry, selected: true }] };
            }
        });
    };
    SimpleFilterGroupComponent.prototype.addSimpleFilter = function () {
        this.filterList.push(null);
        this.triggerUpdate();
    };
    SimpleFilterGroupComponent.prototype.removeSimpleFilter = function (index) {
        this.filterList.splice(index, 1);
        this.triggerUpdate();
    };
    SimpleFilterGroupComponent.prototype.updateSimpleFilters = function (newVal, index) {
        if (index < this.filterList.length) {
            this.filterList[index] = newVal;
        }
        else {
            throw 'Simple filter error: filter index error.';
        }
        this.triggerUpdate();
    };
    SimpleFilterGroupComponent.prototype.triggerUpdate = function () {
        this.updateFilter({
            filterQuery: this.getSimpleFilterExp()
        });
    };
    SimpleFilterGroupComponent.prototype.getSimpleFilterExp = function () {
        var filters = [];
        this.filterList.forEach(function (f) {
            if (f && !f.isDropdown && f.entries && f.entries.some(function (en) { return en.selected; })) {
                var name_3 = f.name, entries = f.entries;
                var tags = entries.filter(function (en) { return en.selected; }).map(function (en) { return name_3 + ":" + en.name; });
                filters.push(new filter_logic_1["default"](filter_logic_1.LOGIC.OR, tags));
            }
            else if (f && f.isDropdown && f.entries && f.entries.some(function (en) { return en.selected; })) {
                var key_1 = f.key, name_4 = f.name, entries = f.entries;
                var codedName_1 = encodeURIComponent(btoa(name_4));
                var dropdownLogic = entries.filter(function (en) { return en.selected; }).map(function (en) { return key_1 + ":" + encodeURIComponent(btoa(en.name)) + ":" + codedName_1; });
                filters.push(new filter_logic_1["default"](filter_logic_1.LOGIC.OR, dropdownLogic));
            }
            else if (f && f.operator && typeof f.value !== 'undefined') {
                var field = f.field, key = f.key, operator = f.operator, value = f.value, template = f.template, display = f.display;
                var codedDisplay = btoa(display);
                var numericLogic = field + ":" + key + ":" + operator + ":" + value + ":" + template + ":" + codedDisplay;
                filters.push(numericLogic);
            }
        });
        return new filter_logic_1["default"](filter_logic_1.LOGIC.AND, filters).toExp();
    };
    return SimpleFilterGroupComponent;
}());
exports.SimpleFilterGroupComponent = SimpleFilterGroupComponent;
angular.module(COMPONENT_NAME, [simple_filter_component_1["default"]]).component("simpleFilterGroup", {
    template: require("./simple-filter-group.component.html"),
    bindings: {
        categories: '<',
        numericObjects: '<',
        initState: '<',
        updateFilter: '&',
        showAlert: '&?'
    },
    controller: SimpleFilterGroupComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=simple-filter-group.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/simple-filter/simple-filter-group.component.js